<template>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title text-center">Telefones de {{ name }}</h4>
        </div>
        <div class="modal-body">
            <vue-simple-spinner v-if="!loaded_phones" class="m-b-20"></vue-simple-spinner>
            <div v-if="loaded_phones && has_phones">
                <div v-if="phone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Telefone</p>
                        <h3 class="m-b-10"><i class="fas fa-phone pull-left"></i> <span>{{ phone }}</span></h3>
                    </div>
                </div>

                <div v-if="cellphone" class="card-box">
                    <div class="text-right">
                        <p class="text-success m-t-5 text-uppercase font-600 font-secondary">Celular</p>
                        <h3 class="m-b-10"><i class="fas fa-mobile-alt pull-left"></i> <span>{{ cellphone }}</span></h3>
                    </div>
                </div>

                <div class="card-box">
                    <a class="text-danger"
                        role="button"
                        data-toggle="collapse"
                        href="#collapseSecurity"
                        aria-expanded="false"
                        aria-controls="collapseSecurity"><b><i class="fas fa-exclamation-triangle"></i> Importante! Clique aqui e conheça nossas orientações de segurança para quando estiver negociando o aluguel com esta pessoa por telefone.</b></a>
                    <div class="collapse" id="collapseSecurity">
                        <ul class="m-t-20">
                            <li>Não faça nenhum depósito antecipado, sem antes visitar o local e conhecer a pessoa que está oferecendo um quarto ou imóvel.</li>
                            <li class="m-t-10">Caso esse anunciante te peça para transferir qualquer valor antecipado, denuncie esta pessoa pelo WebQuarto.</li>
                            <li class="m-t-10">Em caso de dúvidas, solicite o pagamento do primeiro aluguel através da <b><a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/91-o-que-e-a-reserva-segura-no-webquarto">Reserva Segura</a></b>, fazendo o pagamento
                            do primeiro mês de aluguel diretamente através de sua conta no WebQuarto. </li>
                            <li class="m-t-10"><a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/60-como-saber-se-alguem-esta-tentando-me-aplicar-um-golpe">Siga nossas dicas</a>, para saber reconhecer quando alguém está tentando te aplicar um golpe.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-if="loaded_phones && !has_phones && !hidden_phones">
                <div class="alert alert-info">
                    {{ name }} não preencheu nenhum número de telefone em sua conta. Você ainda pode entrar em contato com essa pessoa enviando uma mensagem diretamente para ela, pelo campo acima.
                </div>
            </div>

            <div v-if="loaded_phones && hidden_phones">
                <div class="alert alert-info">
                    <p class="text-dark">
                        {{ name }} optou por não exibir seus números de telefone. Você ainda pode entrar em contato com essa pessoa enviando uma mensagem.
                    </p>
                </div>
            </div>
	    </div>
    </div>
</template>

<script>
	import SimpleSpinner from '../../spinner/Spinner.vue';
	export default {
		props: ['name', 'type', 'fk_user'],
		data: function () {
			return {
				has_phones: false,
				loaded_phones: false,
				phone: '',
				cellphone: '',
				hidden_phones: false
			};
		},
        components: {
            'vue-simple-spinner': SimpleSpinner,
        },
		methods: {
			showPhoneNumbers: function () {
                if (this.loaded_phones)
                    return;

				var instance = this;
				axios.get('/user/get-phonenumbers/' + this.fk_user).then(function (response) {
					var data = response.data;
                    instance.loaded_phones = true;

					if (data.success) {
						instance.phone = data.phone;
						instance.cellphone = data.cellphone;
						instance.has_phones = data.has_phones;

                        window.phone = {
                            phone: data.phone,
                            cellphone: data.cellphone,
                            loaded_phones: true,
                            has_phones: data.has_phones
                        };

						window.dataLayer.push({
							'event': 'show_phone_number',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else {
                        const error = data.error ?? data.msg;

						switch (error) {
                            case 'hidden_phone':
                                instance.hidden_phones = true;
                                instance.loaded_phones = true;
                                break;
                            case 'insuficient_credits':
                                EventBus.$emit('open-modal', 'need-credits-modal');
                                break;
                            case 'need_mobile_verification':
                                EventBus.$emit('open-modal', 'verify-mobile-modal');
                                break;
                            default:
                                window.App.error('Não foi possível visualizar o telefone. Entre em contato com nossa equipe!');
                        }
					}
				}).catch(function (error) {
					if (error.response && error.response.status == 401) {
						EventBus.$emit('open-modal', 'register-modal', {name: instance.name});
						window.dataLayer.push({
							'event': 'show_login_modal',
							'event_category': instance.type,
							'event_label': 'show_phone_number'
						});
					} else
						window.App.error('Ocorreu um erro inesperado. Atualize esta página e tente novamente!');
				});
			}
        },
        mounted () {
            if (window.phone) {
                this.cellphone = window.phone.cellphone;
                this.phone = window.phone.phone;
                this.has_phones = window.phone.has_phones;
                this.loaded_phones = window.phone.has_phones;
            }

        },
		created() {
            this.showPhoneNumbers();
		}
	}
</script>

<style lang="scss" scoped>
    .coins-amount {
        font-weight: bolder;
        color: #5f6261;

        img {
            margin-left: 4px;
            width: 14px;
            height: 14px;
        }
    }
</style>
